<template>
  <div>
    <h1>Whatsapp</h1>
    <input
      v-model="to"
      placeholder="Número de teléfono"
    >
    <textarea
      v-model="text"
      placeholder="Mensaje"
    />
    <button @click="sendMessage">
      Enviar
    </button>
  </div>
</template>
<script>
import axios from 'axios'
import { API_ROUTES } from '@/axios'
export default {
  data () {
    return {
      to: '',
      text: ''
    }
  },
  methods: {
    async sendMessage () {
      try {
        const token = localStorage.getItem('token')
        if (!token) {
          localStorage.removeItem('token')
          this.$router.push('/login')
          return
        }

        // Ensure the 'to' field includes the country code (e.g., '34' for Spain)
        if (!this.to.startsWith('34')) {
          alert('El número debe incluir el prefijo internacional (ej. 34 para España).')
          return
        }

        const response = await axios.post(API_ROUTES.PROVA_WHATSAPP,
          { to: this.to, text: this.text },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          }
        )
        alert(response.data.status)
      } catch (error) {
        console.error('Error al enviar el mensaje:', error)
      }
    }
  }
}
</script>
